export const getWaterTypeName = (v: number) => {
  switch (v) {
    case 1:
      return "管道分质直饮水"
    case 2:
      return "净水器"
    case 3:
      return "桶装水(含九年一贯制)"
    case 4:
      return "开水炉/茶水桶"
    case 5:
      return "自建供水设施"
    case 6:
      return "二次供水设施"
  }
}
